/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { DEFAULT_PULL_REQUEST_URL } from '../../conts';
import axios from 'axios';
import { debounce } from 'lodash';

const usePlaygroundInputs = () => {
  const [prUrl, setPRUrl] = useState(DEFAULT_PULL_REQUEST_URL);
  const [validationError, setValidationError] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const extractPRDetailsFromURL = url => {
    const regex = /https:\/\/github\.com\/([^/]+)\/([^/]+)\/pull\/(\d+)/;
    const match = url.match(regex);
    if (match) {
      return { owner: match[1], repo: match[2], prNumber: match[3] };
    } else {
      return {};
    }
  };

  const validateUrl = debounce(async () => {
    setValidationError('');
    const validateRepoMetadata = async prUrl => {
      try {
        const { owner, repo } = extractPRDetailsFromURL(prUrl);
        const axiosInstance = axios.create({});

        if (!owner || !repo) {
          throw new Error('Cannot extract repo owner and repo');
        }

        const example = `https://api.github.com/repos/${owner}/${repo}`;
        const { data } = await axiosInstance.get(example);
        const { size } = data;

        if (size / 1000 > 150) {
          setValidationError('Repo size must be under 150mb');
        }
      } catch (e) {}
      setInitialized(true);
    };

    const validatePRURL = prUrl => {
      const regex = /^https:\/\/github\.com\/[\w.-]+\/[\w.-]+\/pull\/\d+$/;
      const isPullrequest = regex.test(prUrl);
      if (!isPullrequest) {
        setValidationError('Url is not a valid PR');
        setInitialized(true);
      }
    };
    validatePRURL(prUrl);
    await validateRepoMetadata(prUrl);
  }, 500);

  useEffect(() => {
    if (!prUrl) {
      setValidationError('');
      setInitialized(false);
      return;
    }
    validateUrl();
  }, [prUrl]);

  return {
    prUrl,
    setPRUrl,
    validationError,
    initialized,
    validateUrl
  };
};

export default usePlaygroundInputs;
